import CellAction from './CellAction';

export default CellAction;
